import { useEffect } from "react";

//
//component
//redux
//selector
//actions
export const TriggerClient = ({ handleSearchById, result }) => {
  // -------------------------- VAR ----------------------------

  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    if (result) {
      handleSearchById({ id: result });
    }
  }, [result, handleSearchById]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerClient;
